// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { creditCardDetailsEntryStyles } from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import LinkInfo from "@eisinc/XDL/Icons/LinkInfo";
import { createLinkIconStyles } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsHeading = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

creditCardDetailsEntryStyles.paymetricIframe = {
    css: css`
        width: 100%;
        border: none;
        height: 384px;
    `,
};

creditCardDetailsEntryStyles.paymetricGridItem = {
    width: 12,
    css: css`
        max-width: 100%;
    `,
};

creditCardDetailsEntryStyles.cardNickNameText = {
    css: css`
        width: 100%;
    `,
};

creditCardDetailsEntryStyles.cardTypeImage = {
    imgProps: {
        style: {
            width: "auto",
        },
    },
    css: css`
        margin-right: 10px;
        margin-bottom: 20px;
        opacity: 0.5;
        &.active {
            opacity: 1;
        }
    `,
};

creditCardDetailsEntryStyles.creditCardDetailsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

creditCardDetailsEntryStyles.saveCardGridItem = {
    css: css`
        margin-bottom: 4px;
    `,
};
creditCardDetailsEntryStyles.expirationYearSelect = {
    labelProps: {
        css: css`
            &&& {
                min-height: 14px;
            }
        `,
    },
};
creditCardDetailsEntryStyles.securityCodeGridItemOnePageCheckout = {
    width: [6, 6, 6, 4, 4],
};
creditCardDetailsEntryStyles.expirationYearGridItemOnePageCheckout = {
    width: [6, 6, 6, 4, 4],
};
creditCardDetailsEntryStyles.expirationMonthGridItemOnePageCheckout = {
    width: [6, 6, 6, 4, 4],
};

creditCardDetailsEntryStyles.hintLink = {
    ...createLinkIconStyles({
        icon: LinkInfo,
        linkStyles: {
            icon: {
                position: "right",
                iconProps: {
                    css: css`
                        &&&,
                        &&& ${IconWrapper}, &&& svg {
                            opacity: 1;
                        }
                    `,
                },
            },
        },
    }),
};

creditCardDetailsEntryStyles.cardTypeContainer = {
    css: css`
        display: flex;
        gap: 8px;
    `,
};
